// extracted by mini-css-extract-plugin
export default {"base":"Address_base__b8Yi5","root":"Address_root__h9kdn","content":"Address_content__rZjf4","header":"Address_header__oO9FN","form":"Address_form__kbdJc"};